// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3JYgf","large":"styles_large__giCkw"};